import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import { Box, NerdWalletLogo } from '@nerdwallet/currency';
import BrandHeaderSection from './brand-header-section';

import { stringInputSpec } from '../../lib/editing-configs';
import './brand-header.less';
import sections from './brand-header-sections';

const BrandHeader = ({ pageSection }) => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [headerShadow, setHeaderShadow] = useState(false);

  const handleScrollEvent = useCallback(() => {
    if (window.pageYOffset > 2) {
      setHeaderShadow(true);
    } else setHeaderShadow(false);
  }, []);

  useEffect(() => {
    handleScrollEvent();
    window.addEventListener('scroll', handleScrollEvent, true);
    return () => {
      window.removeEventListener('scroll', handleScrollEvent, true);
    };
  }, [handleScrollEvent]);

  const navToggle = isNavOpen ? 'nav--open' : 'nav--closed';

  const HeaderLinks = _.map(sections, (section) => (
    <BrandHeaderSection
      {...section}
      pageSection={pageSection}
      isNavOpen={isNavOpen}
      setIsNavOpen={setIsNavOpen}
    />
  ));

  return (
    <Box>
      <Box className={classNames('brand-header__nav', navToggle)}>
        <button
          className="brand-header__close"
          type="button"
          isNavOpen={isNavOpen}
          onClick={() => setIsNavOpen(!isNavOpen)}
        >
          &times;
        </button>
        <Box className="brand-header__links">{HeaderLinks}</Box>
      </Box>
      <Box
        className={classNames('brand-header__mask', navToggle)}
        isNavOpen={isNavOpen}
        onClick={() => setIsNavOpen(!isNavOpen)}
      />
      <Box
        className={classNames('brand-header', { 'shadow--on': headerShadow })}
      >
        <Box className="brand-header__logo">
          <NerdWalletLogo />
        </Box>
        <button
          className="brand-header__open"
          type="button"
          isNavOpen={isNavOpen}
          onClick={() => setIsNavOpen(!isNavOpen)}
        >
          &#9776;
        </button>
      </Box>
    </Box>
  );
};

BrandHeader.propTypes = {
  pageSection: PropTypes.string,
};

BrandHeader.defaultProps = {
  pageSection: '',
};

BrandHeader.getEditingConfig = () => [
  stringInputSpec(
    'pageSection',
    'Section of website where this header appears'
  ),
];

BrandHeader.displayName = 'BrandHeader';

export default BrandHeader;
